(() => {
  const sectionSelector = '[data-section-type="collection-template"]';
  const visibleClass = 'collection__filters--visible';
  const openClass = 'kizilco-filters-open';

  function unlockPage() {
    document.documentElement.classList.remove('kizilco-mobile-filters-open');
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
  }

  function getParts(element) {
    const section = element?.closest(sectionSelector);
    return {
      section,
      drawer: section?.querySelector('[data-collection-filters]'),
      toggle: section?.querySelector('[data-toggle-filters]')
    };
  }

  function setOpen(element, open, restoreFocus = false) {
    const { section, drawer, toggle } = getParts(element);
    if (!section || !drawer || !toggle) return;

    section.classList.toggle(openClass, open);
    drawer.classList.toggle(visibleClass, open);
    toggle.setAttribute('aria-expanded', String(open));

    if (!open) unlockPage();

    if (restoreFocus) toggle.focus({ preventScroll: true });
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-toggle-filters]');
    const close = event.target.closest('[data-close-filters]');
    const control = toggle || close;
    if (!control || !control.closest('.template-collection')) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (toggle) {
      const { section } = getParts(toggle);
      setOpen(toggle, !section?.classList.contains(openClass));
    } else {
      setOpen(close, false, true);
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const section = document.querySelector(`.template-collection.${openClass}`);
    if (section) setOpen(section, false, true);
  });

  document.addEventListener('input', (event) => {
    if (!event.target.closest('[data-collection-filters-form]')) return;
    window.setTimeout(unlockPage, 900);
  }, true);

  document.addEventListener('shopify:section:load', unlockPage);
  window.addEventListener('pageshow', unlockPage);
})();
